import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
export const teeImagePopupDispatcher = dispatch => ({
  onClose: () => {
    dispatch(showPopup({
      popup: 'specs'
    }));
  }
});